import { fetchNetlifyAuthToken } from "./netlifyAuthToken";

export const postEmptyCardRelationshipsData = async ({ t, version }) => {
  try {
    // If local dev, set local data
    if (process.env.POWERUP_NAME.includes("LOCAL")) {
      await t.set("organization", "shared", "localCardRelationships", {
        version,
        cardRelationshipsData: {},
      });
    } else {
      // Otherwise, post to Netlify function
      try {
        const token = await fetchNetlifyAuthToken();
        const organization = (await t.organization("id")) || {};
        const response = await fetch(
          "/.netlify/functions/cardRelationshipsApi",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              organizationId: organization.id,
              version,
              data: {},
            }),
          }
        );
        const result = await response.json();

        if (!response.ok) {
          console.error(
            "Response was not ok for postEmptyCardRelationshipsData:",
            result
          );
        }
      } catch (error) {
        console.error("Error in postEmptyCardRelationshipsData:", error);
      }
    }
  } catch (error) {
    console.error("Failed postEmptyCardRelationshipsData:", error);
  }
};
